export const newsList = [
  {
    id: "seoul-night-walk-release",
    title: "《首尔夜行》定档十月，朴叙镇谈城市夜景的拍摄哲学",
    subtitle: "导演朴叙镇与主演李在勋出席定档发布会，分享这部夜戏占七成的悬疑新作。",
    category: "新片动态",
    date: "2025-09-18",
    author: "编辑部 林一",
    readTime: "6 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20press%20conference%20scene%20in%20a%20dim%20Seoul%20theater%2C%20empty%20stage%20with%20a%20large%20moody%20film%20poster%20lit%20by%20warm%20amber%20spotlights%2C%20deep%20navy%20blue%20background%2C%20rain%20visible%20through%20tall%20windows%2C%20professional%20event%20photography%2C%20no%20visible%20text%20on%20people&width=1200&height=675&seq=rk-news-01&orientation=landscape",
    excerpt: "夜戏占全片七成，剧组用四十个夜晚走遍首尔。导演说，这座城市真正的表情只在凌晨两点之后出现。",
    tags: ["首尔夜行", "韩国电影", "新片定档"],
    body: [
      "九月中旬的首尔仍带着夏末的湿气。定档发布会选在城西一家老影院，门口只摆了一张手绘风格的街景海报，没有红毯，也没有惯常的媒体长枪短炮。导演朴叙镇说，这部电影本来就不属于明亮的场合。",
      "《首尔夜行》讲述一名出租车司机在连续三起失踪案之间被卷入追踪的故事。全片约七成场景发生在夜间，剧组在四十个夜晚里走遍了首尔的大小街巷，从钟路的写字楼后巷到汉江边的旧码头。摄影指导坚持使用实景光源，路灯、便利店灯箱与远处车灯构成了整部电影的主要色板。",
      "「白天我们拍城市的功能，夜晚才拍城市的情绪。」朴叙镇在发布会上这样解释他的选择。他提到，团队最初准备了大量人工布光方案，最后几乎全部推翻，因为「灯一亮，街道就不再说实话了」。",
      "主演李在勋为角色减重八公斤，并在开机前跟随真正的夜班司机跑了三周车。他提到最难的一场戏并非动作场面，而是在便利店门口连续等待十七分钟，只用一个眼神完成情绪转折。「导演不喊卡，我也不敢动。」",
      "影片已确认入围本届釜山国际电影节新浪潮单元，并将于十月中旬在韩国正式上映。发行方透露，影片的海外版权已售出至十一个国家和地区，日本与东南亚档期正在协调中。",
      "对于外界关注的续集可能，朴叙镇笑说暂时没有计划：「先把这一夜讲完，剩下的事留给观众自己想。」"
    ],
    relatedIds: ["autumn-jdrama-preview", "kyoto-lost-busan"]
  },
  {
    id: "autumn-jdrama-preview",
    title: "2025 秋季日剧前瞻：五部值得放进追剧清单的新作",
    subtitle: "从悬疑到治愈，这一季的日剧在类型上比往年更敢走极端。",
    category: "追剧指南",
    date: "2025-09-12",
    author: "编辑部 佐野",
    readTime: "8 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Warm%20autumn%20Tokyo%20street%20scene%20at%20dusk%20with%20cinema%20marquee%20lights%20and%20red%20maple%20leaves%2C%20pedestrians%20with%20umbrellas%2C%20deep%20navy%20blue%20sky%20and%20amber%20glow%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20readable%20text&width=1200&height=675&seq=rk-news-02&orientation=landscape",
    excerpt: "本季新剧在题材上明显分化：科幻悬疑与深夜治愈同时发力，短剧集比例继续上升。",
    tags: ["日剧", "秋季档", "追剧清单"],
    body: [
      "日本各大台陆续公布秋季档编排，和去年相比，本季最明显的变化是单集时长与集数的收缩。十集以内的作品占到新剧总数的六成，制作方更愿意把预算集中在少数几部重点作品上。",
      "首先值得关注的是《北纬三十五度》。这部以海边天文台为舞台的悬疑剧，用一段「来自三天后的信号」串起整个小镇的异常。前两集节奏克制，几乎不靠惊吓，而是用环境音和长镜头制造不安感。",
      "第二部是改编自同名漫画的《蓝色急诊室》。医疗题材向来是日剧的稳定输出，但这部把重心放在了医生的心理耗损上，手术场面反而不是重点。女主角樱井遥的表演被不少提前看片的媒体认为是本季最有机会拿奖的一次。",
      "治愈方向则由《月见食堂》接棒。每集一位客人、一道菜，结构简单到近乎固执，但深夜档正好需要这种不催促观众的东西。值得一提的是，剧中的料理全部实拍，没有使用道具替身。",
      "另外两部作品分别是青春群像《东京合租日记》与纪实风格的《京都四季手帖》。前者靠密集的对白和即兴感取胜，后者则几乎没有旁白，把一整年的四季交给画面自己说话。",
      "从目前公布的预告片来看，这一季的日剧并不打算讨好所有人。对观众而言，这或许是好事：至少选择变得清楚了。"
    ],
    relatedIds: ["kyoto-lost-busan", "healing-japanese-film"]
  },
  {
    id: "korean-short-series-trend",
    title: "韩剧制作委员会模式再进化，短剧集成为新趋势",
    subtitle: "从 16 集体量到 8 集精品，韩国电视剧的生产逻辑正在改变。",
    category: "行业观察",
    date: "2025-08-30",
    author: "编辑部 崔允",
    readTime: "7 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Modern%20Seoul%20office%20at%20night%20seen%20through%20glass%2C%20storyboard%20prints%20and%20script%20pages%20on%20a%20conference%20table%2C%20warm%20amber%20desk%20lamps%20against%20deep%20navy%20city%20lights%2C%20restrained%20corporate%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=675&seq=rk-news-03&orientation=landscape",
    excerpt: "平台与制作公司的分成结构在变，观众对「注水」的容忍度也在变。短，正在成为新的竞争力。",
    tags: ["韩剧", "行业", "短剧集"],
    body: [
      "过去十年，十六集几乎是韩剧的默认长度。这个默认值正在被打破。今年上半年上线的韩国剧集中，八到十集的作品占比首次超过三分之一，而二十集以上的长剧只剩下个位数。",
      "变化的直接原因来自制作成本。演员片酬、海外取景与后期特效的价格持续上涨，制作公司很难再靠拉长集数摊薄风险。相反，把故事压缩到八集，反而更容易控制预算并保证单集质量。",
      "另一个推动力来自海外平台。多家流媒体在采购时明确要求「无注水」，并以完播率作为后续合作的重要指标。这让编剧在结构上更接近电影：每一集都必须有独立的高点。",
      "不过，短并不自动等于好。有制片人坦言，部分项目在压缩集数后出现了人物动机不足的问题，「把十六集的内容硬塞进八集，只会更乱」。真正有效的做法是在开发阶段就按短剧集重写人物线。",
      "观众的反馈也相当直接。《第七位证人》用十四集讲完一桩十年旧案，几乎每一集都留下新的疑点；而某些被压缩的恋爱剧则被批评「感情线像快进」。可见长度只是容器，内容密度才是关键。",
      "接下来的一年，预计会有更多介于电影与剧集之间的中篇作品出现。对创作者来说，这也许是一次重新思考叙事节奏的机会。"
    ],
    relatedIds: ["seoul-night-walk-release", "autumn-jdrama-preview"]
  },
  {
    id: "kyoto-lost-busan",
    title: "《京都迷途》亮相釜山影展，映后口碑走高",
    subtitle: "高桥岭新作以一张不存在的地图，带观众走进京都的隐秘巷弄。",
    category: "影展现场",
    date: "2025-10-04",
    author: "特约记者 陈栖",
    readTime: "5 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20Busan%20film%20festival%20outdoor%20screening%20at%20night%2C%20rows%20of%20empty%20seats%20facing%20a%20glowing%20screen%20by%20the%20sea%2C%20deep%20navy%20sky%20with%20a%20warm%20amber%20projector%20beam%2C%20mist%20over%20the%20water%2C%20cinematic%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=675&seq=rk-news-04&orientation=landscape",
    excerpt: "放映结束后，观众提问持续了四十分钟，讨论集中在影片对「记忆与地点」的处理方式上。",
    tags: ["京都迷途", "釜山影展", "日本电影"],
    body: [
      "《京都迷途》在釜山国际电影节「亚洲之窗」单元完成国际首映。放映厅外排队的人流绕过了半个街区，主办方临时增加了一场加映。",
      "影片改编自一部并未公开发行的短篇小说，讲述一位整理古地图的学者在京都旧宅里发现手绘小路的故事。导演高桥岭在映后表示，最初的灵感来自他本人一次真实的迷路经历：「我在京都住了三个月，还是会在同一片街区走错。」",
      "摄影是现场讨论最多的部分。全片几乎没有使用稳定器，镜头跟随人物穿过狭窄的巷弄，观众会产生一种被带着走的感觉。有观众提问为何不用更规整的构图，高桥岭回答：「迷路本来就不规整。」",
      "主演仲村透在片中大量使用关西腔，并为此提前两个月到京都生活。他提到最难的一场戏是在一间没有台词的旧仓库里独自行走十二分钟，「导演只给了我说一句：不要演，只要找。」",
      "影片结尾并未给出明确解释，这也成为映后争论的焦点。高桥岭对此的态度相当坦然：「如果每个人都带着同一个答案离场，那这部电影就太客气了。」",
      "该片已确定于明年春季在日本公映，亚洲其他地区的发行谈判正在进行中。"
    ],
    relatedIds: ["autumn-jdrama-preview", "seoul-night-walk-release"]
  },
  {
    id: "healing-japanese-film",
    title: "从《夏日便利屋》看日本治愈系电影的回潮",
    subtitle: "当叙事不再追求强烈冲突，观众为什么反而愿意留下来？",
    category: "深度专题",
    date: "2025-08-16",
    author: "编辑部 高濑",
    readTime: "9 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20seaside%20town%20at%20blue%20hour%2C%20a%20small%20convenience%20store%20glowing%20warm%20amber%2C%20empty%20street%20with%20utility%20poles%2C%20cicada%20silhouettes%2C%20soft%20navy%20twilight%20sky%2C%20nostalgic%20film%20photography%20texture%2C%20calm%20melancholic%20mood%2C%20no%20text&width=1200&height=675&seq=rk-news-05&orientation=landscape",
    excerpt: "没有反派、没有高潮，这类电影却连续三年在亚洲市场稳定增长。治愈不是逃避，而是一种叙事选择。",
    tags: ["治愈系", "日本电影", "深度"],
    body: [
      "《夏日便利屋》上映首周排片并不占优，但凭借口碑在第三周逆势上涨，最终成为今年日本本土电影的一匹黑马。一部没有反派、没有反转、甚至连明确高潮都不明显的电影，为什么能留住观众？",
      "首先要理解这类作品的叙事单位。传统商业片以「事件」推进，而治愈系电影以「日常」推进：一次做饭、一段散步、一句没说完的话。冲突被缩小到人与人之间的微小摩擦，解决方式也往往只是「坐在一起吃完这顿饭」。",
      "这种结构对剪辑节奏要求极高。太慢会显得空洞，太快又会破坏氛围。《夏日便利屋》的导演小林和也在采访中提到，全片剪掉了将近四十分钟的素材，「不是因为不好，而是因为太满了」。",
      "第二个关键是空间。海边小镇、便利店、蝉鸣、午后雷阵雨，这些元素共同构成一种可被身体记住的夏天。观众未必经历过同样的故事，但几乎都经历过同样的温度。",
      "当然，治愈系也容易滑向套路。近年来不少同类作品被批评为「风景片加鸡汤台词」，人物只剩下功能性的温柔。真正有效的作品，往往愿意让角色保留一点不体面的部分。",
      "从这个角度看，《夏日便利屋》的成功并不神秘。它没有承诺生活变好，只是承认生活有时候确实很难，然后递给你一支冰棍。",
      "接下来还有多部同类型作品排队上映。市场是否已经饱和，很快就会有答案。"
    ],
    relatedIds: ["autumn-jdrama-preview", "korean-short-series-trend"]
  },
  {
    id: "japan-korea-coproduction",
    title: "日韩合拍片升温：跨语言叙事如何找到共鸣",
    subtitle: "从合拍到共创，两国制作团队正在尝试更平等的合作方式。",
    category: "行业观察",
    date: "2025-07-22",
    author: "编辑部 尹素",
    readTime: "8 分钟阅读",
    cover: "https://readdy.ai/api/search-image?query=Filmmaking%20crew%20silhouettes%20on%20a%20pier%20at%20sunrise%2C%20camera%20tripod%20and%20lighting%20equipment%2C%20calm%20sea%20reflecting%20warm%20amber%20light%2C%20deep%20navy%20blue%20sky%20with%20soft%20clouds%2C%20documentary%20behind-the-scenes%20photography%2C%20hopeful%20atmosphere%2C%20no%20readable%20text&width=1200&height=675&seq=rk-news-06&orientation=landscape",
    excerpt: "语言不再是障碍，而是素材本身。多部日韩合拍项目进入后期，合作模式比过去更深入。",
    tags: ["合拍片", "日韩", "行业"],
    body: [
      "过去，日韩合拍更多停留在资本与市场的层面：一方出钱，一方出人。如今情况正在变化，越来越多项目从开发阶段就由两国团队共同参与，剧本会在两种语言之间反复打磨。",
      "正在后期制作中的一部合拍片采用双语言版本，但不是简单的配音，而是让角色在片中真实地面对语言差异。制片人表示，这种处理让「听不懂」本身成为剧情的一部分，而不是需要被消除的障碍。",
      "合作模式的调整也带来了制作流程上的磨合。日本团队习惯在开机前完成极为详细的分镜，韩国团队则更依赖现场调整。两种方法各有优势，冲突往往发生在预算与档期的交界处。",
      "演员的选择同样更谨慎。为了让两种语言都自然，部分项目开始采用双语能力的演员，或在剧本阶段就为角色设定合理的语言背景，而不是等到拍摄时再补救。",
      "市场层面对这类作品保持乐观。亚洲多个地区的发行方表示，只要故事成立，字幕从来不是问题；真正影响接受度的，是作品是否真诚地对待文化差异。",
      "接下来一年内，预计至少有三部日韩合拍作品上映。它们能否形成稳定的类型，还需要观众投票。"
    ],
    relatedIds: ["korean-short-series-trend", "kyoto-lost-busan"]
  }
];